var _rect, _rect2, _text, _text2, _text3, _text4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveBlackjack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4,
    width: 18,
    height: 26,
    rx: 3,
    fill: "#1e293b",
    stroke: "#475569",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 10,
    width: 18,
    height: 26,
    rx: 3,
    fill: "#0f172a",
    stroke: "#6366f1",
    strokeWidth: 1.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 9,
    y: 18,
    fontFamily: "Arial",
    fontSize: 9,
    fontWeight: "bold",
    fill: "#ef4444"
  }, "A")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 9,
    y: 26,
    fontFamily: "Arial",
    fontSize: 7,
    fill: "#ef4444"
  }, "\u2665")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 21,
    y: 24,
    fontFamily: "Arial",
    fontSize: 9,
    fontWeight: "bold",
    fill: "white"
  }, "A")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 21,
    y: 32,
    fontFamily: "Arial",
    fontSize: 7,
    fill: "#94a3b8"
  }, "\u2660")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveBlackjack);
export default __webpack_public_path__ + "static/media/live-blackjack.34044e38c4f86884e8669a38b6631ec1.svg";
export { ForwardRef as ReactComponent };